import { z } from "zod";

export const TrainingRegistrationSchema = z.object({
  full_name: z.string(),
  email: z.string().email("Enter a valid email"),
  phone_number: z.string(),
  whatsapp_number: z.string(),
  date_of_birth: z.string().min(5, "Date of Birth is required."),
  gender: z.string(),
  building_name: z.string(),
  landmark: z.string(),
  city: z.string(),
  district: z.string(),
  state: z.string(),
  postal_code: z.string(),
  training_program: z.string(),
  preferred_time: z.string(),
});
